module.exports = __webpack_public_path__ + "media/images/html_logo-7821a11cc18bedb7290da881b680ad06.png";